
import { BlogPost } from "@/types/blogTypes";
import { parseMetadata } from "@/utils/blogPostUtils";
import { fetchBlogPostBySlug as fetchBlogPostBySlugD1 } from "./d1Service";
import { getAuthHeader } from "./authService";

export async function getBlogPostBySlug(
  slug: string,
  options?: { includeDrafts?: boolean },
): Promise<BlogPost | null> {
  try {
    const authHeaders = getAuthHeader();

    if (options?.includeDrafts && Object.keys(authHeaders).length > 0) {
      const adminResponse = await fetch(`/api/admin/blog/slug/${slug}`, {
        headers: {
          ...authHeaders,
        },
      });
      if (adminResponse.ok) {
        const adminPost = await adminResponse.json();
        return adminPost;
      }
    }

    const post = await fetchBlogPostBySlugD1(slug);
    if (post) {
      return post;
    }

    return null;
  } catch (error) {
    console.error('Error fetching blog post by slug:', error);
    throw error;
  }
}

export async function saveBlogPost(post: Partial<BlogPost>): Promise<BlogPost> {
  try {
    const isUpdate = !!post.id;
    const postData: any = {
      ...post,
      updated_at: new Date().toISOString()
    };

    if (!isUpdate) {
      postData.created_at = new Date().toISOString();
    }

    if (!isUpdate && (!postData.title || !postData.slug || !postData.excerpt || !postData.content)) {
      throw new Error("Required fields missing: title, slug, excerpt, and content are required");
    }

    const url = isUpdate ? `/api/admin/blog/${post.id}` : `/api/admin/blog`;
    const method = isUpdate ? "PUT" : "POST";
    const response = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        ...getAuthHeader(),
      },
      body: JSON.stringify(postData),
    });

    if (!response.ok) {
      const errorBody = await response.json().catch(() => ({}));
      throw new Error(errorBody.error || "Failed to save blog post");
    }

    const result = await response.json();
    
    return {
      ...result,
      metadata: parseMetadata(result.metadata)
    } as BlogPost;
  } catch (error) {
    console.error('Error saving blog post:', error);
    throw error;
  }
}

export async function deleteBlogPost(id: string): Promise<void> {
  try {
    const response = await fetch(`/api/admin/blog/${id}`, {
      method: "DELETE",
      headers: {
        ...getAuthHeader(),
      },
    });

    if (!response.ok) {
      const errorBody = await response.json().catch(() => ({}));
      throw new Error(errorBody.error || "Failed to delete blog post");
    }
  } catch (error) {
    console.error('Error deleting blog post:', error);
    throw error;
  }
}
